module.exports = __webpack_public_path__ + "static/media/company.ccbbe080.jpg";